import React from "react";

import Icon from "metabase/components/Icon";

const SelectSeparator = () => (
  <Icon name="chevronright" size={12} className="mx2 text-medium" />
);

export default SelectSeparator;
